/*
 * Internal page names are defined in PageNameProvider.cs in the Website (www).
 * If you want to use specific page names, please add here.
 * We are trying to maintain only page names front-end code needs instead of adding them all.
 */ 

enum PageNames {
    RollerCoaster = 'RollerCoaster',
    Landing = 'Landing'
};

export default PageNames;